import { render, staticRenderFns } from "./ShowRecoveryCode.vue?vue&type=template&id=1ecb3dbc&"
import script from "./ShowRecoveryCode.vue?vue&type=script&lang=js&"
export * from "./ShowRecoveryCode.vue?vue&type=script&lang=js&"
import style0 from "./ShowRecoveryCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports